/**
 * main.ts
 *
 * Bootstraps plugins then mounts the App`
 */

// Components
import App from './App.vue';

// Custom Directives
import {sanitizeHtmlDirective} from './directives/sanitizeHtmlDirective';

// Composables
import {createApp} from 'vue';

// Plugins
import {registerPlugins} from './core/plugins';

// Import fonts from Fontsource
import '@fontsource-variable/roboto/wght.css';
import '@fontsource-variable/ibm-plex-sans/wght.css';
// Styles
import '../style.css';
import './styles/main.scss';

// Utils
import errorHandler from '@core/services/ErrorHandlerService';

globalThis.addEventListener('vite:preloadError', event => {
  const reloaded = sessionStorage.getItem('chunk-reload');
  if (!reloaded) {
    sessionStorage.setItem('chunk-reload', '1');
    globalThis.location.reload();
  }
  event.preventDefault();
});

const app = createApp(App);

// Register global error handlers
app.config.errorHandler = errorHandler.handleVueError;
addEventListener('error', errorHandler.handleWindowError);
globalThis.addEventListener(
  'unhandledrejection',
  errorHandler.handleUnhandledRejection,
);

app.directive('sanitize-html', sanitizeHtmlDirective);
await registerPlugins(app);

try {
  // Any application logic happening outside of Vue, before the app is mounted
  // can be wrapped in a try-catch block to handle errors
} catch (error) {
  // Handle any errors that occur outside of Vue
  errorHandler.handleWindowError(error as ErrorEvent);
}

app.mount('#app');
